import React from 'react';
export const Footer = () => {
  return <footer className="bg-[#0A2463] text-white" data-id="element-151">
      <div className="max-w-7xl mx-auto py-8 sm:py-12 px-4 sm:px-6 lg:px-8" data-id="element-152">
        <div className="md:flex md:items-center md:justify-between" data-id="element-153">
          <div className="flex flex-col space-y-4 sm:space-y-0 sm:flex-row sm:justify-center md:order-2" data-id="element-154">
            <a href="#" className="text-center sm:text-left text-gray-300 hover:text-white" data-id="element-155">
              Privacy Policy
            </a>
            <span className="hidden sm:inline mx-3 text-gray-300" data-id="element-156">|</span>
            <a href="#" className="text-center sm:text-left text-gray-300 hover:text-white" data-id="element-157">
              Terms of Service
            </a>
            <span className="hidden sm:inline mx-3 text-gray-300" data-id="element-158">|</span>
            
          </div>
          <div className="mt-8 md:mt-0 md:order-1" data-id="element-159">
            <p className="text-center text-sm sm:text-base text-gray-300" data-id="element-160">
              &copy; 2025 A Family Keepsake of Values. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
};